import { apiClient } from './client';
import type { Activation, ActivationWithLicense } from '../../types';

export const activationsService = {
  list: async (params?: {
    limit?: number;
    offset?: number;
    status?: string;
    licenseId?: string;
    eid?: string;
    platform?: string;
    app_version?: string;
    customer_id?: string;
  }): Promise<{ activations: ActivationWithLicense[] }> => {
    return apiClient.get<{ activations: ActivationWithLicense[] }>('/api/v1/activations', params);
  },

  getById: async (id: string): Promise<ActivationWithLicense> => {
    return apiClient.get<ActivationWithLicense>(`/api/v1/activations/${id}`);
  },

  getHistory: async (licenseId: string): Promise<{ history: Activation[] }> => {
    return apiClient.get<{ history: Activation[] }>(`/api/v1/activations/license/${licenseId}/history`);
  },

  deactivate: async (id: string, reason?: string): Promise<Activation> => {
    return apiClient.delete<Activation>(`/api/v1/activations/${id}`, { reason });
  },
};
